export interface FAQCollection {
  name: string;
  description: string;
  numberOfArticles: number;
  articleCollections: ArticleCollection[];
}

export interface ArticleCollection {
  name: string;
  description: string;
  articles: Article[];
}

export interface Article {
  id: string;
  title: string;
  contentHTML: string;
}

export interface Conversation {
  id: string;
  messages: Message[];
  timestamp: Date;
  hasCompleted: boolean;
}

export interface Message {
  id: string;
  sender: MessageSender;
  content: string;
  timestamp: Date;
}

export enum ChatbotPage {
  HOME = 'home',
  AI_ASSISTANT = 'ai-assistant',
  MESSAGES_LIST = 'messages-list',
  FAQ = 'faq',
  CHAT = 'chat',
}

export enum FAQPage {
  COLLECTIONS = 'collections',
  GROUPS_OF_ARTICLES_LISTS = 'groups-of-articles-lists',
  ARTICLES_LIST = 'articles-list',
  READ_ARTICLE = 'read-article',
}

export enum MessageSender {
  USER = 'user',
  AI_ASSISTANT = 'ai-assistant',
  CUSTOMER_SUPPORT = 'customer-support',
}
